import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SecondMenuComponent } from './second-menu/second-menu.component';
import { VarianceComponent } from './variance/variance.component';
import { NursingAuditComponent } from './nursing-audit/nursing-audit.component';
import { AnnouncementManagementGuard, ApplicationAuthGuard, AuthGuardService, FeatureFlagGuard } from './auth-guard.service';
// import { VisualizationComponent } from './visualization/visualization.component';
import { WasteIndexComponent } from './waste-module/waste-index/waste-index.component';
import { PeerToPeerComponent } from './peer-to-peer/peer-to-peer.component';
import { UtilitiesComponent } from './utilities/utilities.component';
import { SupportComponent } from './support/support.component';
import { TermsAndConditionsComponent } from './static/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './static/privacy-policy/privacy-policy.component';
import { AccountManagementComponent } from './account-management/account-management.component';
import { LogsComponent } from './logs/logs.component';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { RetrievalLogCollectComponent } from './waste-module/retrieval-log-collect/retrieval-log-collect.component';
import { ErrorHandlerComponent } from './error-handler/error-handler.component';
import { WitnessGuardService } from './auth-guard.service';
// import { JobsListComponent } from './intake-management/jobs-list/jobs-list.component';
// import { IntakeManagementComponent } from './intake-management/intake-management.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { DdpsGuardService } from './auth-guard.service';
import { RiskScoringComponent } from './risk-scoring/risk-scoring.component'
import { NotificationManagementComponent } from './notification-management/notification-management.component';
import { InsightsComponent } from './insights/insights.component';
import { AcctHomeComponent } from './account-management/acct-home/acct-home/acct-home.component';
import { MedsOfInterestComponent } from './meds-of-interest/meds-of-interest.component';
import { StockAreaConfigComponent } from './stock-area-config/stock-area-config.component';
import { ROUTE_PATHS } from './route-paths';
import { SignedOutComponent } from './signed-out/signed-out.component';
import { LoginComponent } from './login/login.component';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  {
    path: 'login/callback',
    component: OktaCallbackComponent
  },
  {
    path: 'signed-out',
    component: SignedOutComponent
  },
  ...(environment.enableLocalTestAuth ? [{
    path: 'security-login',
    component: LoginComponent
  }] : []),
  {
    path: 'dev/retrievallog-collect',
    component: RetrievalLogCollectComponent,
    data: {
      title: 'Login Page'
    }
  },
  // {
  //   path: '',
  //   component: LoginPreloaderComponent,
  //   canActivate: [],
  //   data: {
  //     title: ''
  //   }
  // },
  {
    path: '',
    component: HomeComponent,
    canActivate: [ApplicationAuthGuard],
    data: {
      title: ''
    }
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [ApplicationAuthGuard],
    data: { title: '' }
  },
  {
    path: 'home/false',
    canActivate: [ApplicationAuthGuard,AuthGuardService],
    component: HomeComponent,
    data: {
      title: '',
      deId: false
    }
  },
  {
    path: 'home/true',
    canActivate: [ApplicationAuthGuard,AuthGuardService],
    component: HomeComponent,
    data: {
      title: '',
      deId: true
    }
  },
  {
    path: 'support',
    canActivate:  [ApplicationAuthGuard,AuthGuardService],
    component: SupportComponent,
  },
  {
    path: 'utilities',
    canActivate: [ApplicationAuthGuard,AuthGuardService, DdpsGuardService],
    component: UtilitiesComponent,
    data: {
      title: ''
    }
  },
  {
    path: 'select-source',
    // canActivate: [],
    component: SecondMenuComponent,
    data: {
      title: ''
    }
  },

  {
    path: 'variance/false',
    component: VarianceComponent,
    data:{deId:false},
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./variance/variance.module').then(m => m.VarianceModule),
      }
    ]
  },
  {
    path: 'variance/true',
    component: VarianceComponent,
    data:{deId:true},
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./variance/variance.module').then(m => m.VarianceModule),
      }
    ]
  },
  {
    path: `${ROUTE_PATHS.riskAssessment}/false`,
    component: NursingAuditComponent,
    data:{deId:false},
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./nursing-audit/nursing-audit.module').then(m => m.NursingAuditModule),
      }
    ]
  },
  {
    path: `${ROUTE_PATHS.riskAssessment}/true`,
    component: NursingAuditComponent,
    data:{deId:true},
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./nursing-audit/nursing-audit.module').then(m => m.NursingAuditModule),
      }
    ]
  },
  {
    path: `${ROUTE_PATHS.assayManagement}/false`,
    component: WasteIndexComponent,
    data: { deId: false, featureFlag: 'enableAssayManagement' },
    canActivate: [ApplicationAuthGuard, AuthGuardService, FeatureFlagGuard, WitnessGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./waste-module/waste-module.module').then(m => m.WasteModuleModule),
      }
    ]
  },
  {
    path: `${ROUTE_PATHS.assayManagement}/true`,
    component: WasteIndexComponent,
    data: { deId: true, featureFlag: 'enableAssayManagement' },
    canActivate: [ApplicationAuthGuard, AuthGuardService, FeatureFlagGuard, WitnessGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./waste-module/waste-module.module').then(m => m.WasteModuleModule),
      }
    ]
  },
  {
    path: 'peer-to-peer/false',
    component: PeerToPeerComponent,
    data:{deId:false},
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./peer-to-peer/peer-to-peer.module').then(m => m.PeerToPeerModule),
      }
    ]
  },
  {
    path: 'peer-to-peer/true',
    component: PeerToPeerComponent,
    data:{deId:true},
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./peer-to-peer/peer-to-peer.module').then(m => m.PeerToPeerModule),
      }
    ]
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./static/static.module').then(m => m.StaticModule),
      }
    ]
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./static/static.module').then(m => m.StaticModule),
      }
    ]
  },
  {
    path: 'accounts',
    component: AccountManagementComponent,
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./account-management/account-management.module').then(m => m.AccountManagementModule),
      }
    ]
  },
  {
    path: 'documents',
    component: AcctHomeComponent,
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./account-management/account-management.module').then(m => m.AccountManagementModule),
      }
    ]
  },
  {
    path: 'meds-of-interest',
    component: MedsOfInterestComponent,
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./meds-of-interest/meds-of-interest.module').then(m => m.MedsOfInterestModule),
      }
    ]
  },
  
  // {
  //   path: 'intake-jobs',
  //   component: IntakeManagementComponent,
  //   // canActivate: [AuthGuardService],
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('./intake-management/intake-management.module').then(m => m.IntakeManagementModule),
  //     }
  //   ]
  // },
  {
    path: 'errors',
    component: LogsComponent,
    canActivate: [ApplicationAuthGuard,AuthGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./logs/logs.module').then(m => m.LogsModule),
      }
    ]
  },
  {
    path: 'error-handler/:id',
    canActivate:  [ApplicationAuthGuard,AuthGuardService],
    component: ErrorHandlerComponent,
    data: {
      title: 'Application Error'
    }
  },
  {
    path: 'configuration',
    component: ConfigurationComponent,
    canActivate: [ApplicationAuthGuard,AuthGuardService, DdpsGuardService, FeatureFlagGuard],
    data: { featureFlag: 'enableConfigurationManagement' },
    children: [
      {
        path: '',
        loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
      }
    ]

  },
  {
    path: 'stock-area-config',
    component: StockAreaConfigComponent,
    canActivate: [ApplicationAuthGuard,AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./stock-area-config/stock-area-config.module').then(m => m.StockAreaConfigModule),
      }
    ]
  },
  {
    path: 'risk-scoring',
    component: RiskScoringComponent,
    canActivate: [ApplicationAuthGuard,AuthGuardService,],
    children: [
      {
        path: '',
        loadChildren: () => import('./risk-scoring/risk-scoring.module').then(m => m.RiskScoringModule),
      }
    ]
  },
  {
    path: 'announcement-management',
    component: NotificationManagementComponent,
    canActivate: [ApplicationAuthGuard,AuthGuardService, FeatureFlagGuard, AnnouncementManagementGuard],
    data: { featureFlag: 'enableNotificationManagement' },
    children: [
      {
        path: '',
        loadChildren: () => import('./notification-management/notification-management.module').then(m => m.NotificationManagementModule),
      }
    ]
  },
  {
    path: 'insights/false',
    component: InsightsComponent,
    data:{deId:false},
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./insights/insights.module').then(m => m.InsightsModule),
      }
    ]
  },
  {
    path: 'insights/true',
    component: InsightsComponent,
    data:{deId:true},
    canActivate: [ApplicationAuthGuard, AuthGuardService, DdpsGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./insights/insights.module').then(m => m.InsightsModule),
      }
    ]
  },
  // { path: 'notification-management', loadChildren: () => import('./notification-management/notification-management.module').then(m => m.NotificationManagementModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
